import { useAuth } from '../context/AuthContext'

export default function DashboardPage() {
  const { user } = useAuth()

  const cards = [
    { label: 'Notas de Venta', value: '—', sprint: 'Sprint 3' },
    { label: 'Remitos pendientes', value: '—', sprint: 'Sprint 6' },
    { label: 'Entregas hoy', value: '—', sprint: 'Sprint 7' },
    { label: 'Alertas activas', value: '—', sprint: 'Sprint 6' },
  ]

  return (
    <div>
      <h2 style={styles.greeting}>Bienvenido, {user?.nombre}</h2>
      <p style={styles.sub}>LGR — Sistema de Gestión Comercial y Logística</p>
      <div style={styles.grid}>
        {cards.map(card => (
          <div key={card.label} style={styles.card}>
            <div style={styles.cardValue}>{card.value}</div>
            <div style={styles.cardLabel}>{card.label}</div>
            <div style={styles.cardSprint}>{card.sprint}</div>
          </div>
        ))}
      </div>
      <div style={styles.info}>
        <h3 style={styles.infoTitle}>Sprint 1 — Base del proyecto ✓</h3>
        <ul style={styles.infoList}>
          <li>Migraciones PostgreSQL — 26 tablas</li>
          <li>Modelos Eloquent con relaciones y scopes</li>
          <li>Autenticación Sanctum + roles Spatie</li>
          <li>API REST CRUD: zonas, fleteros, artículos, clientes, medios de pago, motivos, usuarios</li>
          <li>React + Vite con autenticación y paneles ABM</li>
        </ul>
      </div>
    </div>
  )
}

const styles = {
  greeting: { margin: '0 0 0.25rem', fontSize: '1.5rem', color: '#1e293b' },
  sub: { margin: '0 0 1.5rem', color: '#64748b' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem', marginBottom: '2rem' },
  card: { background: 'white', padding: '1.25rem', borderRadius: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' },
  cardValue: { fontSize: '2rem', fontWeight: '700', color: '#1e40af', marginBottom: '0.25rem' },
  cardLabel: { fontSize: '0.875rem', fontWeight: '600', color: '#334155', marginBottom: '0.25rem' },
  cardSprint: { fontSize: '0.75rem', color: '#94a3b8' },
  info: { background: 'white', padding: '1.5rem', borderRadius: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' },
  infoTitle: { margin: '0 0 1rem', color: '#1e293b' },
  infoList: { margin: 0, color: '#475569', lineHeight: '1.8' },
}
